import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DataFieldIndexResource } from "../../../shared/types/dataField";
import { PermissionName } from "../../../shared/types/permission";
import { dataFieldService } from "../shared/api/dataFieldService";
import { hasDataFieldOptions } from "../shared/utils/dataField";

interface Props {
	dataField: DataFieldIndexResource;
	handleEditOption: (id: Id) => void;
	handleEdit: () => void;
	handleDelete: (id: Id) => Promise<boolean>;
}

export const DataFieldListContextMenu: FC<Props> = ({ dataField, handleEditOption, handleEdit, handleDelete }) => {
	const { t } = useTranslation();
	const showUsageAction = useCallback(
		() => dataFieldService.showUsage(dataField.id).then((r) => r.data.data),
		[dataField.id],
	);
	const canUpdate = useHasPermission<PermissionName>(["dataField.update"]);
	const canDelete = useHasPermission<PermissionName>(["dataField.delete"]);

	return (
		<ContextMenu displayShortcutsAs="icon">
			{canUpdate && (
				<ContextMenuItem
					title={t("Edit data field")}
					label={t("Edit data field")}
					action={handleEdit}
					icon="edit"
					shortcut="primary"
				/>
			)}
			{canUpdate && hasDataFieldOptions(dataField.type) && (
				<ContextMenuItem
					title={t("Edit data field options")}
					label={t("Edit data field options")}
					action={() => handleEditOption(dataField.id)}
					shortcut="default"
					icon="list"
				/>
			)}
			{canDelete && (
				<ContextMenuDeleteWithModelUsageItem
					title={t("Delete data field")}
					label={t("Delete data field")}
					showUsageAction={showUsageAction}
					modelName={t("Data field")}
					confirmationBody={t("Are you sure you want to delete this data field?")}
					deleteAction={() => handleDelete(dataField.id)}
				/>
			)}
		</ContextMenu>
	);
};
